module.exports = __webpack_public_path__ + "assets/img/btn-view-d651317e.png";